import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=cec1bfda&scoped=true&"
import script from "./DialogComponent.vue?vue&type=script&lang=js&"
export * from "./DialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=cec1bfda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec1bfda",
  null
  
)

export default component.exports